export default __webpack_public_path__ + "static/media/33.6499a488.png";